import { FilterOperator } from 'src/hooks/meilisearch/types/filter-value';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';
import { getSelectedFilters } from './get-selected-filters';

export const toggleFilterItemSelection = (
  filterType: string,
  value: string,
  singleOption: boolean,
  filters: Filters,
  handleChangeFilterValue: HandleChangeFilterValue,
  filterOperator?: FilterOperator | undefined,
) => {
  let selectedCopy = getSelectedFilters(filters, filterType);

  if (singleOption) {
    if (selectedCopy.includes(value)) {
      selectedCopy = [];
    } else {
      selectedCopy = [value];
    }
  } else {
    if (selectedCopy.includes(value)) {
      selectedCopy = selectedCopy.filter(item => item !== value);
    } else {
      selectedCopy.push(value);
    }
  }

  handleChangeFilterValue(filterType, selectedCopy, filterOperator);
};
